import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { HttpService } from 'src/app/core/services/http.service';

@Component({
  selector: 'app-policy-intermediary-code-field',
  templateUrl: './policy-intermediary-code-field.component.html',
  styleUrls: ['./policy-intermediary-code-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class PolicyIntermediaryCodeFieldComponent implements OnInit, OnDestroy {
  @Input() fromFile: boolean = false;
  @Input() label: string = 'Policy Intermediary Code';
  @Input() controlName: string = 'policy_intermediary_code';
  @Input('required') isRequired = false;
  form: FormGroup;

  constructor(private ctrlContainer: FormGroupDirective, private http: HttpService) {}

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;
    this.form.addControl(
      this.controlName,
      new FormControl('')
    );
  }

  ngOnDestroy(): void {
    this.form.removeControl(this.controlName);
  }

  onCsvUpload(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const url = '/services/api/v1/payout/ei-codes';
    this.http.post(url, formData).subscribe((res: any) => {
      if (res) {
        this.form.controls[this.controlName].patchValue(res);
      }
    });
  }

  transformValue(): void {
    const currentValue = this.form.controls[this.controlName].value;
    if (currentValue) {
      const transformed = currentValue
        .split(',')
        .map((v: string) => v.trim())
        .filter((v: string) => v !== '');

      this.form.controls[this.controlName].setValue(transformed, { emitEvent: false });
    }
  }
}
